import { useModalForms } from '../../../../modalForms/modalFormsContext';
import { useTypeAndDescription } from '../typeAndDescriptionContext';

import { Container } from './style';

export function ButtonNextForm() {
    const { handleConfirmTypeAndDescription } = useTypeAndDescription()
    const { alertButtonToClickHim } = useModalForms()

    return(
    <Container 
        onClick={() => handleConfirmTypeAndDescription()}
        breathButton={alertButtonToClickHim?.breathButton && alertButtonToClickHim?.index === 1}
    >
        Continuar
    </Container>
    )
}

